/// <reference types="vite/client" />

import { useGameStore } from './store/gameStore';

const BASE_URL = import.meta.env.BASE_URL || '/';
const BASE_PATH = BASE_URL.length > 1 ? BASE_URL.replace(/\/$/, '') : '';

const ROOM_PATH_RE = new RegExp(`^${escapeRegExp(BASE_PATH)}/([a-zA-Z0-9]{6})/?$`);

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function roomCodeFromUrl(path: string = window.location.pathname): string | null {
  const m = path.match(ROOM_PATH_RE);
  return m ? m[1].toUpperCase() : null;
}

export function navigateToRoom(code: string): void {
  const target = `${BASE_PATH}/${code.toUpperCase()}`;
  if (window.location.pathname !== target) {
    window.history.pushState({}, '', target);
  }
}

export function navigateToHome(): void {
  const dest = BASE_PATH ? `${BASE_PATH}/` : '/';
  if (window.location.pathname !== dest) {
    window.history.pushState({}, '', dest);
  }
}

export function roomShareUrl(code: string): string {
  const path = `${BASE_PATH}/${code.toUpperCase()}`;
  return `${window.location.origin}${path}`;
}

/** Read the room code from the URL and restore a stored seat, or prefill Join. */
export function resolveRoomFromUrl(): string | null {
  const code = roomCodeFromUrl();
  const st = useGameStore.getState();

  if (!code) {
    st.setPendingJoinCode(null);
    return null;
  }

  if (st.roomCode === code && st.myPlayerId && st.identity) {
    st.setPendingJoinCode(null);
    return code;
  }

  if (st.restoreIdentityForRoom(code)) {
    st.setPendingJoinCode(null);
    return code;
  }

  st.setPendingJoinCode(code);
  return code;
}
